<template>
  <div v-bind="$attrs" class="link flex-center gap-xs no-highlights" role="button" type="button" tabindex="0"
  :class="{
    'flex-row-reverse': props.rtl,
    'flex-row': !props.rtl,
  }">
    <Icons :icon :background :color=colorizeColor :style="focusStyle" :size :theme class="unselectable"/>
    <span class="primary-font link-description text-overflow-ellipsis text-align-center" role="presentation" :class="[theme, `${font}`,`${primary ? 'primary-font-color' : 'secondary-font-color'}`]" >
      <slot/>
    </span>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import { Icons } from '../icons'
import { IconsModel,type TypeIcons, type TypeColor, Color, type TypeSize, Size, type TypeStyleIcons, IconsStyle, type TypeTheme, Theme } from '../../interfaces'

export interface PropsLink {
  icon?: TypeIcons
  color?: TypeColor
  background?: TypeColor
  size?: TypeSize
  style?: TypeStyleIcons
  rtl?: boolean
  theme?: TypeTheme
  font?: string
  primary?: boolean
}
const props = withDefaults(defineProps<PropsLink>(), {
  icon: IconsModel.previous,
  color: Color.sun,
  background: Color.white,
  size: Size.sm,
  style: IconsStyle.fill,
  theme: Theme.primary,
  font: 'label-md-300',
  rtl: false,
  primary: true,
})
const focus = ref(false)
const colorizeColor = computed(() => {
  return focus.value ? props.background : props.color
})
const focusStyle = computed(() => {
  return focus.value ? props.style === IconsStyle.fill ? IconsStyle.outline : IconsStyle.fill : props.style
})

</script>
<style lang="scss" scoped>
div.link {
  background: none;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
}
div.link :focus-within {
    border: thin solid black;
}
span {
  text-decoration-color: var(--primary-font-color, #53565A);
  text-decoration: underline;
}
span.none {
  background-color: transparent;
  text-transform: none;
  text-decoration: none;
}
.link-description {
  @media screen and (max-width: 150px) {
    // visibility: hidden;
  }
}
.link:focus {
  .primary-font-color {
    color: var(--secondary-font-color, #FFFFFF);
    // text-shadow:  1px 1px 1px var( --button-primary-text-shadow-color, '#393939');
    // outline: 1px solid var(--secondary-font-color, #FFFFFF);
  }
  .secondary-font-color {
    color: var(--primary-font-color, #53565A);
    // text-shadow:  1px 1px 1px var( --button-primary-text-shadow-color, '#FFFFFF');
    // outline: 1px solid var(--primary-font-color, #FFFFFF);
  }
}
</style>
